import RestrictedRegistry, { RestrictedRegistryName } from '../../../components/RestrictedRegistry';
import React, { useEffect, useState } from 'react';

// import PageTitle from '../../components/PageTitle';
import PageTitle from '../../../components/PageTitle';

import BootstrapTable from 'react-bootstrap-table-next';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import paginationFactory from 'react-bootstrap-table2-paginator';
import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit';
import * as FeatherIcon from 'react-feather';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import { Card, CardBody, Col, Input, Row } from 'reactstrap';
import PreloaderWidget from '../../../components/Loader';
import { list_Incubatee, list_Internship, list_internship_application } from '../../../helpers/actions/api.functions';
const InternshipApplicationList = () => {
    const [data, setData] = useState([]);
    const [isActive, setIsActive] = useState(true);
    const [internshipNames, setInternshipNames] = useState([]);
    const [selectedInternship, setSelectedInternship] = useState('All');

    const getInternship = () => {
        setIsActive(true);
        list_Internship()
            .then((res) => {
                setIsActive(false);
                setInternshipNames(res.data); // Keep the entire internship object
            })
            .catch((err) => {
                setIsActive(false);
                toast.error(err.response?.data?.message || 'Failed to load internship data');
            });
    };

    const getInternshipApplications = (internshipId = 'All') => {
        setIsActive(true);

        const params = internshipId !== 'All' ? { internship_id: internshipId } : {};

        list_internship_application(params)
            .then((res) => {
                setIsActive(false);
                setData(res.data);
            })
            .catch((err) => {
                setIsActive(false);
                toast.error(err.response?.data?.message || 'Failed to load data');
            });
    };

    const filteredData =
        selectedInternship === 'All'
            ? data
            : data.filter((item) => item.internship?.id?.toString() === selectedInternship.toString());

    useEffect(() => {
        getInternship();
    }, []);

    const defaultSorted = [
        {
            dataField: 'id',
            order: 'desc',
        },
    ];

    const columns = [
        {
            dataField: 'user.name',
            text: 'Name',
            sort: true,
            formatter: (cell, row) => <RestrictedRegistryName user={row.user} />,
        },
        {
            dataField: 'user.email',
            text: 'Email',
            sort: true,
            formatter: (cell, row) => <div>{row.user?.email || '-'}</div>,
        },
        {
            dataField: 'user.mobile',
            text: 'Mobile',
            sort: true,
            formatter: (cell, row) => <div>{row.user?.mobile || '-'}</div>,
        },
        {
            dataField: 'university',
            text: 'University',
            sort: true,
        },
        {
            dataField: 'degree_program',
            text: 'Degree Program',
            sort: true,
        },
        {
            dataField: 'major',
            text: 'Major',
            sort: true,
        },
        {
            dataField: 'year_of_study',
            text: 'Year',
            sort: true,
        },
        {
            dataField: 'cgpa',
            text: 'CGPA',
            sort: true,
        },
        {
            dataField: 'status',
            text: 'Status',
            formatter: (cell) => (
                <div
                    className={`badge ${
                        cell === 'pending'
                            ? 'badge-soft-warning'
                            : cell === 'approved'
                            ? 'badge-soft-success'
                            : 'badge-soft-danger'
                    }`}>
                    {cell.charAt(0).toUpperCase() + cell.slice(1)}
                </div>
            ),
        },
        {
            dataField: 'id',
            text: 'Action',
            formatter: (cell, row) => (
                <div className="booking-actions">
                    <RestrictedRegistry user={row.user} iconOnly sourceType="internship_application" sourceId={row.id} canMark={row.can_restrict_user} onChanged={() => getInternshipApplications(selectedInternship)} />
                    <Link className="booking-action-button booking-action-button--view" title="View application" aria-label="View application" to={`/Internship-application-detail/${cell}`}>
                        <FeatherIcon.Eye size={18} strokeWidth={1.8} aria-hidden="true" />
                    </Link>
                </div>
            ),
        },
    ];

    const sizePerPageRenderer = ({ options, currSizePerPage, onSizePerPageChange }) => (
        <React.Fragment>
            <label className="d-inline mr-1">Showw</label>
            <Input
                type="select"
                name="select"
                id="no-entries"
                className="custom-select custom-select-sm d-inline col-1 pl-1"
                defaultValue={currSizePerPage}
                onChange={(e) => onSizePerPageChange(e.target.value)}>
                {options.map((option, idx) => {
                    return (
                        <option key={idx} value={option.page}>
                            {option.text}
                        </option>
                    );
                })}
            </Input>
            <label className="d-inline ml-1">entries</label>
        </React.Fragment>
    );
    // const { SearchBar } = Search;

    useEffect(() => {
        getInternshipApplications();
    }, []);
    if (isActive) {
        return <PreloaderWidget />;
    }
    return (
        <React.Fragment>
            <Row className="page-title">
                <Col md={12}>
                    <PageTitle
                        breadCrumbItems={[
                            { label: 'Internship Applications', path: '/internship-application-list', active: true },
                        ]}
                        title={'Internship Applications'}
                    />
                </Col>
            </Row>
            <Row>
                <Card className="w-100">
                    <CardBody>
                        <ToolkitProvider
                            bootstrap4
                            keyField="id"
                            data={data}
                            columns={columns}
                            exportCSV={{ onlyExportFiltered: true, exportAll: false }}>
                            {(props) => (
                                <React.Fragment>
                                    <Row className="mb-3">
                                        <Col md={4} style={{ position: 'relative' }}>
                                            <Input
                                                type="select"
                                                style={{
                                                    backgroundColor: '#f8f9fa',
                                                    // border: '2px solid #007bff',
                                                    borderRadius: '8px',
                                                    padding: '6px 30px 6px 12px',
                                                    fontWeight: '500',
                                                    color: '#333',
                                                    outline: 'none',
                                                    boxShadow: 'none',
                                                    cursor: 'pointer',
                                                    appearance: 'none',
                                                    WebkitAppearance: 'none',
                                                    MozAppearance: 'none',
                                                }}
                                                value={selectedInternship}
                                                onChange={(e) => {
                                                    setSelectedInternship(e.target.value);
                                                    getInternshipApplications(e.target.value);
                                                }}>
                                                <option value="All">All Internships</option>
                                                {internshipNames.map((internship) => (
                                                    <option key={internship.id} value={internship.id}>
                                                        {internship.title}
                                                    </option>
                                                ))}
                                            </Input>

                                            {/* Custom arrow */}
                                            <span
                                                style={{
                                                    position: 'absolute',
                                                    right: '28px', // adjust this to move left or right
                                                    top: '24%',
                                                    transform: 'translateY(-50%) , translateX(50%)',
                                                    pointerEvents: 'none',
                                                    fontSize: '12px',
                                                    color: '#333',
                                                }}>
                                                ▼
                                            </span>
                                        </Col>

                                        {/* <Col md={8} className="text-right">
                                            <SearchBar {...props.searchProps} />
                                        </Col> */}
                                    </Row>

                                    <BootstrapTable
                                        {...props.baseProps}
                                        bordered={true}
                                        defaultSorted={defaultSorted}
                                        pagination={paginationFactory({
                                            sizePerPage: 5,
                                            sizePerPageRenderer: sizePerPageRenderer,
                                            sizePerPageList: [
                                                { text: '5', value: 5 },
                                                { text: '10', value: 10 },
                                                { text: '25', value: 25 },
                                                { text: 'All', value: data.length },
                                            ],
                                        })}
                                        wrapperClasses="table-responsive"
                                    />
                                </React.Fragment>
                            )}
                        </ToolkitProvider>
                    </CardBody>
                </Card>
            </Row>
        </React.Fragment>
    );
};

export default InternshipApplicationList;
